module.exports = __webpack_public_path__ + "static/media/isdoctorplan-obgyn2.6daf3ff2.png";